export enum TaskPositionEnum {
    NonChosen = null,
    NoPosition = 0,
    Won = 1,
    Lost = 2,
    Postponed = 3,
    Closed = 4,
    AdministrationConsultant = 5,
    AwaitingCustomer = 6,
    Interview = 7,
    Internal = 8,
    Extension = 9,
}
